<template>
  <ion-modal :is-open="isOpenModal" :backdrop-dismiss="false" class="custom-alert-modal">
    <div class="modal-content">
      <div class="icon-container">
        <ion-icon :icon="phonePortraitSharp" class="phone-icon"></ion-icon>
      </div>

      <h2>Penting: Jangan Lewatkan Konfirmasi</h2>
      <p class="description">Kasir membutuhkan waktu 1-5 menit untuk cek stok.</p>

      <div class="whatsapp-box">
        <p>
          <strong>Aktifkan notifikasi WhatsApp</strong> agar Anda bisa menutup halaman ini tanpa takut pesanan batal
          otomatis.
        </p>
      </div>

      <ion-button @click="sendWaNotification()" expand="block" class="wa-button">
        <ion-icon slot="start" :icon="logoWhatsapp"></ion-icon>
        Mau, Ingatkan Saya via WhatsApp
      </ion-button>

      <!-- <p class="dismiss-text" @click="close">
        Tidak, saya akan menunggu di layar ini
      </p> -->
    </div>
  </ion-modal>
</template>

<script>
import { useOutletStore } from "@/stores/outlet"
import { IonModal, IonIcon, IonButton } from '@ionic/vue';
import { logoWhatsapp, phonePortraitSharp } from 'ionicons/icons';

export default {
  name: ["waNotifModal"],
  props: ["isOpenModal"],
  components: {
    IonModal,
    IonIcon,
    IonButton,
  },
  setup() {
    return {
      phonePortraitSharp,
      logoWhatsapp
    };
  },
  computed: {
    outletStore() {
      return useOutletStore()
    }
  },
  methods: {
    close() {
      this.$emit("closeModal")
    },
    async sendWaNotification() {
      console.log("Mendaftarkan notifikasi WA...");
      const invoice = this.outletStore.currentInvoice;
      if (!invoice) {
        console.warn("Invoice is empty, redirecting to home...");
        const id = this.$route.params.id;
        this.$router.push(`/${id}`);
        return;
      }
      const url = `${process.env.VUE_APP_BASE_URL}v1/orders/subscribe-request`;

      const myHeaders = new Headers({
        "Public-Key": `${process.env.VUE_APP_PUBLIC_KEY}=`,
        "Content-Type": "application/json"
      });

      try {
        const res = await fetch(url, {
          method: "POST",
          body: JSON.stringify({ order_id: invoice }),
          headers: myHeaders,
        });

        if (res.ok) {
          const result = await res.json();
          const whatsappUrl = result?.data?.whatsapp_url;

          if (whatsappUrl) {
            this.openWhatsapp(whatsappUrl);
          } else {
            console.error("Link WhatsApp tidak ditemukan");
          }
        } else {
          console.error("Gagal mendapatkan link WhatsApp, status:", res.status);
          const id = this.$route.params.id;
          this.$router.push(`/${id}`);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    },

    openWhatsapp(url) {
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      if (isMobile) {
        window.location.href = url;
      } else {
        window.open(url, '_blank', 'noopener,noreferrer');
      }
    }
  }
}

</script>

<style scoped>
/* Menyesuaikan ukuran modal agar tidak full screen (seperti di gambar) */
ion-modal.custom-alert-modal {
  --height: auto;
  --width: 90%;
  --max-width: 400px;
  --border-radius: 24px;
  --box-shadow: 0 28px 48px rgba(0, 0, 0, 0.4);
}

.modal-content {
  padding: 30px 20px;
  text-align: center;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icon-container {
  background: #e6f9f0;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.phone-icon {
  font-size: 30px;
  color: #2dd36f;
}

h2 {
  font-weight: 800;
  color: #1a202c;
  font-size: 1.3rem;
  margin: 0 0 15px 0;
}

.description {
  color: #718096;
  font-size: 0.95rem;
  margin-bottom: 20px;
}

.whatsapp-box {
  color: #4a5568;
  font-size: 0.9rem;
  line-height: 1.5;
  margin-bottom: 25px;
}

.wa-button {
  --background: #2dd36f;
  --background-activated: #28ba62;
  --border-radius: 12px;
  font-weight: bold;
  text-transform: none;
  width: 100%;
  height: 50px;
}

.dismiss-text {
  margin-top: 20px;
  color: #a0aec0;
  font-size: 0.85rem;
  cursor: pointer;
}
</style>